import { Text } from '@reveni-io/reveni-ui'

import { getAddressLines } from '../helpers'
import * as Styles from './styles'

const AddressOption = ({ address, differingFields }) => {
  return (
    <Styles.Container>
      {getAddressLines(address).map(line => (
        <Styles.Line key={line.key}>
          {line.parts.map(part => (
            <Text
              key={part.field}
              tag="span"
              type={differingFields.includes(part.field) ? 'bodyMBold' : 'bodyMRegular'}
            >
              {part.value}
            </Text>
          ))}
        </Styles.Line>
      ))}
    </Styles.Container>
  )
}

export default AddressOption
